'use strict';

var _regeneratorRuntime = require("C:\\Users\\gssak\\Desktop\\block-image\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\gssak\\Desktop\\block-image\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var blake = require('blakejs');

var minB = 0xb201;
var minS = 0xb241;
var blake2b = {
  init: blake.blake2bInit,
  update: blake.blake2bUpdate,
  digest: blake.blake2bFinal
};
var blake2s = {
  init: blake.blake2sInit,
  update: blake.blake2sUpdate,
  digest: blake.blake2sFinal // Note that although this function doesn't do any asynchronous work, we mark
  // the function as async because it must return a Promise to match the API
  // for other functions that do perform asynchronous work (see sha.browser.js)
  // eslint-disable-next-line

};

var makeB2Hash = function makeB2Hash(size, hf) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(data) {
        var ctx;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                ctx = hf.init(size, null);
                hf.update(ctx, data);
                return _context.abrupt("return", Buffer.from(hf.digest(ctx)));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

module.exports = function (table) {
  for (var i = 0; i < 64; i++) {
    table[minB + i] = makeB2Hash(i + 1, blake2b);
  }

  for (var _i = 0; _i < 32; _i++) {
    table[minS + _i] = makeB2Hash(_i + 1, blake2s);
  }
};